import { useState, memo, useCallback } from 'react';
import StageButton from '../StageButton';
import { TableCell } from '@mui/material';
import ConfirmationDialog from './ConfirmationDialog';
import { StyledTableCell } from 'Utils';
import { sendRequest, REQUEST_ACTIONS } from 'utils/Communicator';
import { useDispatch, useSelector } from 'react-redux';
import { snackbarToggle } from 'reducers/snackbarSlicer';

const Confirmation = ({ order, loginUser, pageName }) => {
    const dispatch = useDispatch();
    const failedCallback = useCallback(
        m => dispatch(snackbarToggle({ type: 'error', m })),
        [dispatch],
    );
    const getStatus = () => {
        var stage = order.orderStage ? order.orderStage[0] : null;
        if (order.location?.id != 2) {
            if (order.incoterms?.id == 1 || order.incoterms?.id == 2 || order.incoterms?.id == 3 || order.incoterms?.id == 4 || order.incoterms?.id == 5 || order.incoterms?.id == 6) {
                stage = {};
                stage.status = "dissable";
                stage.notes = "";
            }
        }
        return stage;
    }
    const currentStage = order.orderStage ? order.orderStage[0] : null;

    const [openDialog, setOpenDialog] = useState(false);
    //const onHandleOpenDialog = () => setOpenDialog(true);
    const [order1, setOrder1] = useState(false);
    const onHandleOpenDialog = () => {
        sendRequest('/api/order/' + order.id, REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                var res = JSON.parse(JSON.stringify(response));
                setOrder1(res);
                setOpenDialog(true);
            },
            failedCallback,
        });
    }

    return (
        <StyledTableCell style={{ width: "5vw", p: 0 }}>
            <StageButton stage={getStatus()} onHandleOpenDialog={onHandleOpenDialog} stageName='Confirm' loginUser={loginUser} />
            {openDialog && <ConfirmationDialog loginUser={loginUser} order={order} openDialog={openDialog} setOpenDialog={setOpenDialog} pageName={pageName} />}
        </StyledTableCell>
    );
};

export default memo(Confirmation);
